import * as React from 'react';
import { Dialog as BonesDialog, DialogProps } from 'vet-bones/components';

import { DIALOG_CLOSE_ICON_TEST_ID } from 'src/ui/constants/testIds';

export const Dialog: React.VFC<DialogProps> = ({ ...dialogProps }) => (
  <BonesDialog closeIconTestId={DIALOG_CLOSE_ICON_TEST_ID} {...dialogProps} />
);
